function init() {
  window.addEventListener('load', (event) => {
    
    let counter = 0;
    let i = setInterval(function(){
      const cookieLayer = document.querySelector('.cc-window');
      if (cookieLayer) {
      	this.cookieLayer();
        clearInterval(i);
      }
      counter++;
      if(counter === 25) {
        clearInterval(i);
      }
    }, 200);
  })
}

function cookieLayer() {
  const cookieLayer = document.querySelector('.cc-window');
  const cookieLayerButton = document.querySelector('.footer__blocks-wrapper > .footer-block--menu li:last-child');
  const cookieButton = document.createElement('button');
  cookieButton.classList.add('cookie-layer--button');
  const cookieText = cookieButton.innerHTML = "Cookie-Einstellungen";
  cookieLayerButton.after(cookieButton)
  
  cookieButton.addEventListener('click', () => {
	cookieLayer.style.display = null;
  });
  
}


this.init();